import styled from 'styled-components';

export const Container = styled.main`
  #item {
    :not(:last-child) {
      margin-bottom: 0.6rem;
    }
  }
`;

export const Texto = styled.span`
  display: inline-block;
  text-align: center;
  font-size: 1.4rem;
  font-weight: ${({ isBold }) => (isBold ? 700 : 'normal')};
  color: ${({ theme }) => theme.colors.PRIMARY};
  font-style: normal;
  line-height: 1.8rem;
  text-align: center;

  @media only screen and (min-width: 768px) {
    font-size: 2.2rem;
    line-height: 2.8rem;
    letter-spacing: 0em;
    margin: 0 ${({ isBold }) => (isBold ? 0 : 3)}rem;
  }
`;

export const Titulo = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 2.3rem;
  text-align: center;

  color: ${({ theme }) => theme.colors.PRIMARY};
  margin-bottom: 2.5rem;

  @media only screen and (min-width: 768px) {
    font-size: 2.2rem;
    line-height: 2.765rem;
    letter-spacing: 0em;
    padding: 0 1rem;
  }
`;

export const TextoModal = styled.span`
  font-family: Source Sans Pro;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  line-height: 1.8rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.PRIMARY};

  @media only screen and (min-width: 768px) {
    font-size: 1.8rem;
    line-height: 2.263rem;
    margin: 0 ${({ isBold }) => (isBold ? 0 : 2)}rem;
  }
`;
